// extracted by mini-css-extract-plugin
export var container = "_o7-0";
export var dotAnimation = "_o7-2";
export var dotsLoading = "_o7-1";